import React, { useState } from "react";
import { Link } from "react-router-dom";
import List from "@mui/material/List";
import "./sidebar.css";

import logo from "../../assets/images/favicon.svg";

import SidebarItem from "./SidebarItem";

import { BiDollarCircle, BiHomeAlt, BiWallet, BiCategoryAlt } from "react-icons/bi";
import {
  HiOutlineSpeakerphone,
  HiOutlinePresentationChartLine,
  HiOutlineCog,
  HiUserGroup,
  HiUser,
  HiOutlineCheckCircle,
  HiChatAlt2,
} from "react-icons/hi";
import { shallowEqual, useSelector } from "react-redux";

// starting the component
const Sidebar = (props) => {
  const defaultItems = [
    {
      display_name: "Главная",
      route: "/",
      icon: <BiHomeAlt />,
    },
    {
      display_name: "Тарифы",
      route: "/tariffs",
      icon: <BiWallet />,
    },
  ];

  const reducer_user = useSelector((state) => state.reducer.user, shallowEqual);

  const admin = [
    {
      display_name: "Главная",
      route: "/",
      icon: <BiHomeAlt />,
    },
    {
      display_name: "Реклама",
      route: "/advertising",
      icon: <HiOutlineSpeakerphone />,
    },
    {
      display_name: "Подтвердить объявления",
      route: "/confirm",
      icon: <HiOutlineCheckCircle />,
    },
    {
      display_name: "Тарифы",
      route: "/tariffs",
      icon: <BiWallet />,
    },

    {
      display_name: "Статистика",
      route: "/dashboard",
      icon: <HiOutlinePresentationChartLine />,
    },
    {
      display_name: "Управление",
      route: "",
      icon: <HiOutlineCog />,
      collapse: [
        {
          display_name: "Управление категориями.",
          route: "/category",
          icon: <BiCategoryAlt />,
        },

        {
          display_name: "Управление пользователями",
          route: "/users",
          icon: <HiUser />,
        },
        {
          display_name: "Управление группами",
          route: "/group",
          icon: <HiUserGroup />,
        },
        {
          display_name: "Управление тарифами",
          route: "/tariff_control",
          icon: <BiWallet />,
        },
        {
          display_name: "Управление сообщениями",
          route: "/message",
          icon: <HiChatAlt2 />,
        },
      ],
    },

    // {
    //   display_name: "История платежей",
    //   route: "/history",
    //   icon: <BiHistory />,
    // },
    //{
    //   display_name: "Настройки",
    //   route: "/settings",
    //   icon: <HiOutlineCog />,
    // },
  ];
  const role = reducer_user?.roles;
  const items = role?.includes("ROLE_SUPPER_ADMIN") ? admin
    : role?.includes("ROLE_ADMIN") ? [...defaultItems, {
      display_name: "Реклама", route: "/advertising", icon: <HiOutlineSpeakerphone />,
    }]
    : role?.includes("ROLE_MODERATOR") ? [...defaultItems, {
      display_name: "Статистика", route: "/dashboard", icon: <HiOutlinePresentationChartLine />,
    }, {
      display_name: "Управление тарифами", route: "/tariff_control", icon: <BiWallet />,
    }]
    : defaultItems;

  const [money, setMoney] = useState(false);
  return (
    <div className="sidebar">
      <div className="sidebar__content">
        <div className="sidebar__logo">
          <img src={logo} alt="company logo" />
          <h2 style={{ margin: "20px" }}>TeleGogle</h2>
        </div>
        <List
          sx={{ width: "100%" }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          {items.map((item, index) => (
            <Link
              to={{
                pathname: item.route,
                state: item.route,
              }}
              key={index}
            >
              <SidebarItem
                collapsem={money}
                collapseHandler={(e) => setMoney(e)}
                title={item.display_name}
                icon={item.icon}
                collapse={item.collapse}
                route={item.route}
              />
            </Link>
          ))}
        </List>

        <SidebarItem
          title={`${
            reducer_user ? (reducer_user.balance ? reducer_user.balance : 0) : 0
          } сум`}
          icon={<BiDollarCircle />}
          className={`exit-btn ${!money ? "d-block" : "d-none"}`}
        />
      </div>
    </div>
  );
};

export default Sidebar;
